import React, { useEffect } from "react";
import "./index.scss";

const StationProcess = ({ data = {}, getItem }) => {
  const clickItem = (obj) => {
    getItem && getItem(obj);
  };

  return (
    <div
      className="deviceProcess"
      style={{
        width: data.canvasWidth,
        height: data.canvasHeight,
        backgroundImage: `url(${data.canvasBg})`,
      }}
    >
      {data.deviceDTOList &&
        data.deviceDTOList.map((item) => {
          return (
            <div
              key={item.id}
              onClick={() => clickItem(item)}
              style={{
                position: "absolute",
                width: item.width,
                height: item.height,
                left: item.posX,
                top: item.posY,
                backgroundColor: "rgba(45, 255, 226, .2)",
                cursor: "pointer",
              }}
            ></div>
          );
        })}
    </div>
  );
};

export default StationProcess;
